import {
  AppBar,
  Drawer,
  Grid,
  Hidden,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
} from "@material-ui/core";
import IconButton from "@material-ui/core/IconButton";
import { withStyles } from "@material-ui/core/styles";
import AccountCircle from "@material-ui/icons/AccountCircle";
import MenuIcon from "@material-ui/icons/Menu";
import classNames from "classnames";
import React from "react";
import logo from "../images/logo-sem-fundo.png";
import Routes from "../routes/Routes";
import { colors } from "../styles";
import Header from "./Header";
import SideList from "./SideList";
const drawerWidth = 280;

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    height: "100%",
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 10,
  },
  hide: {
    display: "none",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 7,
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing.unit * 9,
    },
  },
  toolbar: {
    backgroundColor: colors.primary_darker,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0 2px",
    ...theme.mixins.toolbar,
  },
  content: {
    flexGrow: 1,
    backgroundColor: colors.main,
    flex: 1,
    overflow: "auto",
  },
  img: {},
  perfil: {
    marginRight: 10,
  },
});

class MiniDrawer extends React.Component {
  state = {
    open: true,
    anchorEl: null,
  };

  handleResize = () => {
    // this.setState({
    //     windowHeight: window.innerHeight,
    //     windowWidth: window.innerWidth
    // })
    if (window.innerWidth < 800) this.setState({ open: false });
    if (window.innerWidth > 800) this.setState({ open: true });
  };
  componentWillMount() {
    this.handleResize();
  }

  handleClick = (event) => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  componentDidMount() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  }

  componentWillUnmount() {
    // this.handleResize();
    window.removeEventListener("resize", this.handleResize);
  }

  handleDrawerOpen = () => {
    this.setState({ open: !this.state.open });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes } = this.props;

    const { user } = this.props.auth.user;

    return (
      <div className={classes.root}>
        <Hidden smUp>
          <Header logout={this.props.logout} />
        </Hidden>
        <Hidden xsDown>
          <AppBar
            position="absolute"
            className={classNames(
              classes.appBar,
              this.state.open && classes.appBarShift
            )}
            style={{ backgroundColor: colors.primary_darker }}
            elevation={1}
          >
            <Toolbar disableGutters={true}>
              <Grid container>
                <Grid item lg={6} md={6} sm={6} xs={6}>
                  <IconButton
                    color="inherit"
                    aria-label="Open drawer"
                    onClick={this.handleDrawerOpen}
                    className={classNames(classes.menuButton)}
                  >
                    <MenuIcon />
                  </IconButton>
                </Grid>
                <Grid
                  container
                  justify="flex-end"
                  alignItems="center"
                  item
                  lg={6}
                  md={6}
                  sm={6}
                  xs={6}
                >
                  <Typography color="inherit" >{user.profile ? user.profile.toUpperCase() : ""}</Typography>
                  <Grid item>
                    <IconButton
                      color="inherit"
                      className={classes.perfil}
                      onClick={(event) => this.handleClick(event)}
                      aria-owns={this.state.anchorEl ? "simple-menu" : null}
                      aria-haspopup="true"
                    >
                      <AccountCircle />
                    </IconButton>
                    <Menu
                      id="simple-menu"
                      anchorEl={this.state.anchorEl}
                      open={Boolean(this.state.anchorEl)}
                      onClose={this.handleClose}
                    >
                      <MenuItem
                        onClick={() =>
                          this.props.navigate(
                            user.is_user ? "/profile_passenger" : "/profile"
                          )
                        }
                      >
                        Perfil
                      </MenuItem>
                      <MenuItem onClick={() => this.props.logout()}>
                        Logout
                      </MenuItem>
                    </Menu>
                  </Grid>
                </Grid>
              </Grid>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(
                classes.drawerPaper,
                !this.state.open && classes.drawerPaperClose
              ),
            }}
            open={this.state.open}
          >
            <div className={classes.toolbar}>
              <img
                src={logo}
                alt="airshuttle"
                className={classNames(
                  classes.img,
                  !this.state.open && classes.hide
                )}
                style={{ height: 45 }}
              />
            </div>
            {/* <Divider /> */}
            <SideList />
          </Drawer>
        </Hidden>
        <main className={classes.content}>
          <div className={classes.toolbar} />
          <Routes />
        </main>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(MiniDrawer);



// WEBPACK FOOTER //
// ./src/components/Menu.js